module.exports = __webpack_public_path__ + "img/replay-button-old.f4d90e74.png";